module.exports = __webpack_public_path__ + "public/StoreIcon/logout.svg?ad961f34";